export const validation = {
  regex: {
    email: new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"),
    phoneNumber: new RegExp("^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{4}[-s.]?[0-9]{4,6}$"),
    password: new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$&()\\-`,\\/])[a-zA-Z0-9!@#$&()\\-`,\\/]{6,128}$",
    ),
  },
}
